import { TEXT_LINK_FOCUS_RING } from '../lib/a11yFocus'
import UniversalPageLayout from '../components/BaseComponents/UniversalPageLayout/UniversalPageLayout'
import routes from '../components/Router/routes'

const CompanySupport = () => (
	<UniversalPageLayout
		documentTitle={routes.companySupport.name}
		heading={{ title: 'Help & Support' }}
	>
		<div className='mt-5 p-4 bg-charcoal-600 rounded'>
			<p className='text-white mb-4'>
				Please start by visiting our <a className={`underline text-algae-500 ${TEXT_LINK_FOCUS_RING}`} href="http://help.neoni-app.com/" target="_blank" rel="noopener noreferrer">Help Centre</a> for guidance.
			</p>

			<p className='text-white'>
				If this has not solved your issue, you can contact someone in our Support Team by emailing <a className={`underline text-algae-500 ${TEXT_LINK_FOCUS_RING}`} href="mailto:support@neoni-app.com">support@neoni-app.com</a>. This will automatically raise a support ticket in our system and we will get back to you as soon as possible.
			</p>
		</div>
	</UniversalPageLayout>
)

export default CompanySupport
